import { fetchQuery } from 'relay-runtime';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const query = graphql`
  query validateContractPdfQuery(
    $contractor: ID!
    $name: String!
    $description: String!
    $category: ID!
    $contractTemplate: ID!
    $jobDeadline: Date
    $contractSignDeadline: Date
    $totalValue: Decimal
    $deliverables: [ID]
    $contractDate: Date
  ) {
    validateContractPdf(
      contractor: $contractor
      name: $name
      description: $description
      category: $category
      contractTemplate: $contractTemplate
      jobDeadline: $jobDeadline
      contractSignDeadline: $contractSignDeadline
      totalValue: $totalValue
      deliverables: $deliverables
      contractDate: $contractDate
    ) {
      errors
    }
  }
`;

export default variables =>
  fetchQuery(getEnvironment(), query, variables).then(({ validateContractPdf }) => ({
    errors: JSON.parse(validateContractPdf.errors)
  }));
